import axios from "axios";
import { getAccessToken, getURL, saveAccessToken } from "../utils/Utils";

const baseUrl = getURL("API");

const api = axios.create({
  baseURL: baseUrl,
  withCredentials: true,
});

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + getAccessToken(),
};

// REQUEST INTERCEPTOR
api.interceptors.request.use((config) => {
  const token = getAccessToken();

  if (token) {
    config.headers["Authorization"] = "Bearer " + token;
  }

  config.headers["Content-Type"] = "application/json";

  return config;
});

// RESPONSE INTERCEPTOR
api.interceptors.response.use(
  (response) => {
    const sessionToken = response.headers["session-token"];

    if (sessionToken) {
      saveAccessToken(sessionToken);
    }

    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      originalRequest.url !== "/refreshToken"
    ) {
      originalRequest._retry = true;

      try {
        const refreshResponse = await api.post("/refreshToken");
        console.log(refreshResponse);
        const newToken = refreshResponse?.data?.msg;

        if (newToken) {
          saveAccessToken(newToken);
          window.dispatchEvent(new Event("authChanged"));
        }

        originalRequest.headers["Authorization"] = "Bearer " + newToken;

        return api(originalRequest);
      } catch (refreshError) {
        console.error("Token refresh failed:", refreshError);
        sessionStorage.removeItem("sessionToken");
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  },
);

let get = (url) => api.get(url);
let post = (url, data) => api.post(url, data);
let put = (url, data) => api.put(url, data);
let del = (url) => api.delete(url);

export { get, post, put, del, baseUrl };
